import React from 'react';
import { Spinner } from 'react-bootstrap';

const ButtonContent = ({texto, textoCarregando, carregando = false}) => (
    <>
        <Spinner as="span" className='mr-2' animation="border" size="sm" role="status" aria-hidden="true" hidden={!carregando} />
        {carregando ? textoCarregando : texto}
    </>
)
export default ButtonContent;